import { Pipe, PipeTransform } from '@angular/core';


/**
 * Utility class to not hardcode sort directions
 */
export class SortOptions {
  /**
   * Static property to defined ASC and DESC values
   * to avoid hardcoding and repeating
   * replaces string enums
   */
  static direction: {
    ASC: string,
    DESC: string,
  } = {
      ASC: 'ASC',
      DESC: 'DESC',
    };
}



/**
 * Pipe used to filter array, takes input array and
 * array of 2 arguments, key of object and search term
 * if key does not exist, pipe assumes the item is string
 */
@Pipe({
  name: 'arrayFilterParameter',
})
export class ArrayFilterParameterPipe implements PipeTransform {

  // transform(array: Array<{}>, args: string[]): Array<string> | Array<{}> {

  //   array = array || [];

  //   if (typeof args === 'undefined' || args.length !== 2) {
  //     return array;
  //   }

  //   const [key, searchTerm] = args;

  //   if (searchTerm.trim() === '') {
  //     return array;
  //   }

  //   return array.filter((item: {}) => item[key].toString().toLowerCase().search(searchTerm.toLowerCase().trim()) >= 0);
  // }
  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;
  
    return items.filter(item => {
      return Object.keys(item).some(key => {
        return String(item[key]).toLowerCase().includes(searchText.toLowerCase());
      });
    });
   }
}
